var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditQty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.564,
    height: 29.342,
    viewBox: "0 0 30.564 29.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-10 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11667",
    "data-name": "Path 11667",
    d: "M23.754,60a1.528,1.528,0,0,1,1.528,1.528V73.143a1.528,1.528,0,0,1-1.528,1.528H11.528A1.528,1.528,0,0,1,10,73.143V61.528A1.528,1.528,0,0,1,11.528,60Z",
    transform: "translate(0 -33.329)",
    fill: "#ffcc68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11668",
    "data-name": "Path 11668",
    d: "M31.89,60v6.724a.611.611,0,0,1-.847.564l-.348-.145a.611.611,0,0,0-.571.053l-.344.226a.611.611,0,0,1-.671,0l-.344-.226a.611.611,0,0,0-.571-.053l-.348.145A.611.611,0,0,1,27,66.724V60Z",
    transform: "translate(-11.804 -33.329)",
    fill: "#027ef1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11669",
    "data-name": "Path 11669",
    d: "M73.754,60a1.528,1.528,0,0,1,1.528,1.528V73.143a1.528,1.528,0,0,1-1.528,1.528H61.528A1.528,1.528,0,0,1,60,73.143V61.528A1.528,1.528,0,0,1,61.528,60Z",
    transform: "translate(-34.718 -33.329)",
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11670",
    "data-name": "Path 11670",
    d: "M81.89,60v6.724a.611.611,0,0,1-.847.564l-.348-.145a.611.611,0,0,0-.571.053l-.344.226a.611.611,0,0,1-.671,0l-.344-.226a.611.611,0,0,0-.571-.053l-.348.145A.611.611,0,0,1,77,66.724V60Z",
    transform: "translate(-46.522 -33.329)",
    fill: "#ce3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11671",
    "data-name": "Path 11671",
    d: "M47.977,12A1.528,1.528,0,0,1,49.5,13.528V25.143a1.528,1.528,0,0,1-1.528,1.528H34.528A1.528,1.528,0,0,1,33,25.143V13.528A1.528,1.528,0,0,1,34.528,12Z",
    transform: "translate(-15.97)",
    fill: "#ffdd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11672",
    "data-name": "Path 11672",
    d: "M56.89,12v6.724a.611.611,0,0,1-.847.564l-.348-.145a.611.611,0,0,0-.571.053l-.344.226a.611.611,0,0,1-.671,0l-.344-.226a.611.611,0,0,0-.571-.053l-.348.145A.611.611,0,0,1,52,18.724V12Z",
    transform: "translate(-29.163)",
    fill: "#099718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11673",
    "data-name": "Path 11673",
    d: "M75.963,22.519a1.528,1.528,0,0,0-2.161,0L66.023,30.3a1.525,1.525,0,0,0-.3.433,1.026,1.026,0,0,1-.064.116,1.561,1.561,0,0,0-.119.227l-1.412,3.313a1.223,1.223,0,0,0,1.6,1.6l3.313-1.412q.067-.029.13-.062a1.017,1.017,0,0,1,.124-.056,1.522,1.522,0,0,0,.541-.35l7.779-7.779a1.528,1.528,0,0,0,0-2.161Z",
    transform: "translate(-37.511 -6.993)",
    fill: "#ff7a00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11674",
    "data-name": "Path 11674",
    d: "M92.6,22.519a1.528,1.528,0,0,1,2.161,0l1.651,1.651a1.528,1.528,0,0,1,0,2.161l-1.5,1.5L91.1,24.023Z",
    transform: "translate(-56.31 -6.993)",
    fill: "#ce3b3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditQty);
export default __webpack_public_path__ + "static/media/editQty.994b0b025ea941150b154689cdb1e502.svg";
export { ForwardRef as ReactComponent };